export default __webpack_public_path__ + "media/images/ico_search-1e356eed892abef3f498e6caf7aaeb1f.png";